export const formatMomentDateTime = (date, format = 'MMM DD YYYY HH:mm:ss') => {
    if (date.isValid()) return date.format(format);

    return '';
};

export function formatLabel(string, isTitle = false) {
    // Use a regex to match each part of the string
    const words = string.match(/[A-Z][a-z]+|[a-z]+|\d+/g);

    // Capitalize the first letter of each word
    const formattedLabel = words
        .map(word => word.charAt(0)
            .toUpperCase() + word.slice(1))
        .join(' ');

    // Return the formatted label in uppercase if isTitle is true
    return isTitle ? formattedLabel.toUpperCase() : formattedLabel;
}